import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import Button from "../../Helpers/Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import { useConsultantQAIRMutation } from "../../../Redux/service/IR/IR";
import { toast } from "react-toastify";
import Loader from "../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import { editData, storeData } from "../../../utils/IndexedDB";

export default function InspectionRequestConsultantQA({
	refetch,
	setQAAction,
	irId,
	setAction,
}) {
	const initialValues = {
		result: null,
		comments: null,
	};
	const [result, setResult] = useState(null);
	const [AddCQA, { isLoading }] = useConsultantQAIRMutation();
	let { currentIRId, setReloadData, setcurrentIRId } = useContext(popupcontext);
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const inf = useSelector((state) => state.users.user);
	let addQA = useFormik({
		initialValues,
		onSubmit: async (val) => {
			try {
				val.result = result;
				if (!offlineMode) {
					await AddCQA({ id: currentIRId, val }).unwrap();
					toast.success(trans("IR Consultant Review Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setQAAction(false);
					setReloadData(true);
					refetch();
				} else {
					await storeData("OfflineModeData", "IRQA", irId?.id, {
						id: irId?.id,
						uid: irId?.uid,
						userId: inf?.id,
						comments: val.comments,
						result: val.result,
						configurationName: irId?.configurationName,
						project_name: irId?.project?.name,
						zone_name: irId?.zone?.name,
						level_name: irId?.level?.name,
						room_name: irId?.room?.name,
						type: irId?.type,
						statusSync: "Pending Sync",
					});
					await editData("OfflineModeData", "IR", irId?.id, {
						...irId,
						statusSync: "Pending Sync",
					});
					toast.success(trans("IR Consultant Review Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setAction(true);
					setQAAction(false);
				}
			} catch (error) {
				console.log("errr", error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	if (isLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<form onSubmit={addQA.handleSubmit}>
			<TextAreaInput
				title={trans("Comments")}
				rows={3}
				placeholder={trans("Enter your comments")}
				id="comments"
				name="comments"
				onChange={(e) => addQA.handleChange(e)}
				onBlur={(e) => addQA.handleBlur(e)}
			/>
			<div className="d-flex align-items-center mt-2">
				<Button
					htmlType="submit"
					type="primary"
					text="Approve"
					onClick={() => setResult("APPROVED")}
					disabled={addQA.values.comments}
				/>
				<Button
					htmlType="submit"
					type="primary"
					text={trans("Approve With Comments")}
					onClick={() => {
						addQA.setFieldValue("result", "APPROVED_WITH_COMMENTS");
						setResult("APPROVED_WITH_COMMENTS");
					}}
					className="mx-2"
					disabled={
						addQA.values.comments === null || addQA.values.comments === ""
					}
				/>

				<Button
					htmlType="submit"
					danger={true}
					text="Reject"
					type="default"
					onClick={() => setResult("REJECTED")}
				/>
			</div>
		</form>
	);
}
